module.exports = __webpack_public_path__ + "static/media/167-macao.2699499a.svg";